<template>
    <v-card>
        <v-toolbar color="primary" dark>
            <v-toolbar-title class="dialog-toolbar">
                Part Photo
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-responsive class="ma-auto" max-width="560">
                        <v-file-input
                            ref="fileInput"
                            v-model="fileToUpload"
                            accept="image/*"
                            class="custom-height mt-2 pr-16"
                            variant="outlined"
                            label="Click here to take a photo of the part"
                            hint="Select a photo to upload"
                            persistent-hint
                            color="blue-darken-4"
                            prepend-icon="mdi:mdi-camera"
                            clearable
                            chips
                            @click:clear="onClearClicked_Files"
                            @change="handlePhotoPreview"
                        ></v-file-input>
                    </v-responsive>
                </v-col>
            </v-row>
            <v-row class="justify-center">
                <v-btn
                    color="error"
                    @click="closePartPhotoScreen"
                    class="custom-large-btn mr-10"
                    variant="elevated"
                >
                    <span class="button-text">Exit</span>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="uploadPhoto"
                    class="custom-large-btn ml-10"
                    variant="elevated"
                    :disabled="!this.fileToUpload"
                >
                    <span class="button-text">Submit</span>
                </v-btn>
            </v-row>
            <div class="text-center mt-5" v-if="previewImage">
                <img :src="previewImage" alt="Photo Preview" />
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from "axios";

export default {
    name: "JobInfo",
    props: {
        part: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            fileToUpload: null,
            previewImage: null,
            uploaded: false,
            uploadLocation: "",
        };
    },
    methods: {
        async uploadPhoto() {
            try {
                const formData = new FormData();

                formData.append("File", this.fileToUpload[0]);
                formData.append("Part", this.part);
                await axios
                    .post(route("legacy-api.addPartPhoto"), formData)
                    .then((res) => {
                        this.uploadLocation = res.data;
                    })
                    .finally(() => {
                        this.uploaded = true;
                    });
            } catch (err) {
                console.log(err);
            }
        },
        onClearClicked_Files() {
            this.fileToUpload = null;
            this.previewImage = null;
        },
        handlePhotoPreview() {
            const fileInput = this.$refs.fileInput;
            const selectedFile = fileInput.files[0];

            if (selectedFile) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.previewImage = reader.result;
                };
                reader.readAsDataURL(selectedFile);
            }
        },
        closePartPhotoScreen() {
            this.$emit("closePartPhotoScreen");
        },
    },
};
</script>

<style scoped>
.dialog-toolbar {
    font-size: 2em;
    line-height: 1.2;
}
.custom-large-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.25vw;
    padding: 60px 60px;
    width: 10%;
}
.button-text {
    display: inline-block;
}
.custom-height {
    height: 20vh;
}
:deep(.v-icon.mdi.mdi-camera) {
    font-size: 5em;
}
:deep(.v-input__details) {
    align-items: flex-start;
}
</style>
